import { IClientShort } from 'modules/admin-panel/models';
import { IResponse } from './ResultPagesInterfaces';

export interface IResponseRoundList extends IResponse {
	content: IRoundCard[];
}

export interface IRoundCard {
	roundId: string;
	roundNumber: number;
	roundsAmount: number;
	name: string;
	status: SurveyRoundStatus;
	surveyId: string;
	endDate: string;
	respondentsAmount: number;
}

export interface IAllSurveysResultReducer {
	surveyRoundList: IRoundCard[];
	totalRoundElements?: number;
	roundsPerPage: number;
	employees: null | IEmployees[];
	error: null | Error;
	isLoading?: boolean;
	searchQuery: ISearch;
	isClientListLoading: boolean;
	isSurveyRoundListLoading: boolean;
	clientList: IClientShort[];
	activeClient?: IClientShort;
}

export interface ISearch {
	clientId?: string;
	startDate?: string;
	endDate?: string;
	query?: string;
}

export interface ISearchWithPagination extends ISearch {
	page: number;
	size: number;
}

export interface ISurveyData {
	searchQuery: ISearch;
}

export interface IEmployees extends ISearch {
	northeastLatitude?: number;
	northeastLongitude?: number;
	southwestLatitude?: number;
	southwestLongitude?: number;
}

export enum SurveyRoundStatus {
	PENDING = 'PENDING',
	COMPLETE = 'COMPLETE',
	PARTIAL = 'PARTIAL',
	ERROR = 'ERROR',
	NO_RESULTS = 'NO_RESULTS',
}
